import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { loginUser, receiveToken, doInit } from '../../actions/auth';

import logo_img from '../../images/logo.png';
import { withTranslation } from '../../i18n/LanguageContext';
import LanguageSelect from '../../i18n/LanguageSelect';

class Login extends React.Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
    };

    static isAuthenticated() {
      const user = localStorage.getItem('user');
      if (!user) return;
      const date = new Date().getTime() / 1000;
      const data = JSON.parse(user);
      if (!data) return;

      return date < data.expires_in + data.issued;
    }

    constructor(props) {
        super(props);

        this.state = {
          username: '',
          password: ''
        };

        this.doLogin = this.doLogin.bind(this);
        this.changeUsername = this.changeUsername.bind(this);
        this.changePassword = this.changePassword.bind(this);
    }

    changeUsername(event) {
        this.setState({ username: event.target.value });
    }

    changePassword(event) {
        this.setState({ password: event.target.value });
    }

    doLogin(e) {
        e.preventDefault();
        if (this.props.isFetching) {
            return;
        }
        this.props.dispatch(loginUser({ username: this.state.username, password: this.state.password, grant_type: 'password' }));
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.isFetching && this.props.isFetching) {
            return;
        }
        if (Login.isAuthenticated() && this.props.history.location.pathname === '/login') {
            this.props.history.replace('/admin/products');
        }
    }

    componentDidMount() {
        const params = new URLSearchParams(this.props.location.search);
        const token = params.get('token');
        if (token) {
            this.props.dispatch(receiveToken(token));
            this.props.dispatch(doInit());
        }
    }

    render() {
        const { t } = this.props;
        return (
            <div id="page_sign_in">
                <div className="login-shell">
                    <div className="login-card">
                    <form onSubmit={this.doLogin}>
                        <div className="login-card__header">
                            <img src={logo_img} className="login-card__logo" alt={t('login.logoAlt')} />
                            <h2 className="login-card__title">{t('login.title')}</h2>
                        </div>

                        {this.props.errorMessage && (
                            <Alert className="alert-sm login-card__alert" color="danger">
                                {this.props.errorMessage}
                            </Alert>
                        )}

                        <div className="login-card__fields">
                            <div className="form-group">
                                <label htmlFor="login-username">{t('login.username')}</label>
                                <input
                                    id="login-username"
                                    type="text"
                                    className="form-control"
                                    value={this.state.username}
                                    onChange={this.changeUsername}
                                    placeholder={t('login.usernamePlaceholder')}
                                    required
                                    name="username"
                                    autoComplete="username"
                                    autoCapitalize="none"
                                    autoCorrect="off"
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="login-password">{t('login.password')}</label>
                                <input
                                    id="login-password"
                                    type="password"
                                    className="form-control"
                                    value={this.state.password}
                                    onChange={this.changePassword}
                                    placeholder={t('login.passwordPlaceholder')}
                                    required
                                    name="password"
                                    autoComplete="current-password"
                                />
                            </div>
                        </div>

                        <button
                            type="submit"
                            className="btn login-card__submit"
                            disabled={this.props.isFetching}
                            aria-busy={this.props.isFetching}
                        >
                            {this.props.isFetching ? t('login.submitting') : t('login.submit')}
                        </button>
                    </form>
                        <LanguageSelect id="login-display-language" variant="login" />
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        isFetching: state.auth.isFetching,
        isAuthenticated: state.auth.isAuthenticated,
        errorMessage: state.auth.errorMessage,
    };
}

const ConnectedLogin = withRouter(connect(mapStateToProps)(withTranslation(Login)));
ConnectedLogin.isAuthenticated = Login.isAuthenticated;
export default ConnectedLogin;
